import React from 'react';
import { NetlifyProps } from '../../types';
import { AboutPageTemplate } from "../../templates/about-page";

const IndexPagePreview = ({ entry, widgetFor }: NetlifyProps) => {
  const data = entry.getIn(['data']).toJS();

  if (data) {
    return (
      <AboutPageTemplate
        image={data.image}
        body={widgetFor('body')}
      />
    );
  }
  return <div>Loading...</div>;
};

export default IndexPagePreview;
